// src/app/redux/sagas/mesAvantagesSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";
import { API_BASE_URL, getRequest } from "../../../api";

import {
    FETCH_MES_AVANTAGES_REQUEST,
    setMesAvantagesLoading,
    fetchMesAvantagesSuccess,
    fetchMesAvantagesFailure,
} from "../actions/mesAvantagesActions";

const extractErrorMessage = (error, fallback) => {
    let msg = fallback;
    if (error?.response?.data?.message) msg = error.response.data.message;
    else if (error?.response?.data?.error) msg = error.response.data.error;
    else if (error?.message) msg = error.message;
    return msg;
};

// ===================== FETCH MES AVANTAGES =====================
export function* fetchMesAvantagesSaga() {
    const token = sessionStorage.getItem("token");
    // ✅ URL CORRIGÉE pour correspondre au controller
    const url = `${API_BASE_URL}/api/paramavantages/mes-avantages`;

    yield put(setMesAvantagesLoading(true));

    try {
        const response = yield call(getRequest, { url, token });

        // ✅ La réponse contient { avantages: [...], categories: [...] }
        const data = response?.data || response;

        yield put(fetchMesAvantagesSuccess(data));
        yield put(setMesAvantagesLoading(false));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur lors du chargement de vos avantages");
        yield put(fetchMesAvantagesFailure(msg));
        yield put(setMesAvantagesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    }
}